/* eslint-disable functional/no-conditional-statement */
/* eslint-disable functional/immutable-data */
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";

/**
 * The function is check show/hide HeaderFullContent or HeaderShortContent.
 * For the partners isn't HeaderShortContent setting, an App is choose HeaderFullContent for all pages.
 * With the partners have HeaderShortContent setting, an App is load HeaderFullContent for pages isn't belong to Checkout scope.
 * Link items:
 *   https://dev.azure.com/digikey/Portfolio/_workitems/edit/472419
 *   https://dev.azure.com/digikey/Portfolio/_workitems/edit/587259
 * @param pathname string
 */
export function checkShowHeaderFullContent(pathname: string) {
  // Below is list of page is not belong to a Checkout scope.
  const isNotCheckout =
    pathname === `${getPartnerPathnameClient(true)}/purchases` ||
    pathname === `${getPartnerPathnameClient(true)}/samples` ||
    pathname === `${getPartnerPathnameClient(true)}/success`;

  const headerFullDOM = document.getElementById("main-partner-header");
  const headerShortDOM = document.getElementById("main-partner-header-short");

  // Check the Header Short HTML content is available. If Header Short HTML isn't exists, a Header Full HTML will apply for all pages.
  const isHeaderShortExists =
    !!headerShortDOM && !!headerShortDOM.childElementCount;

  if (!!headerFullDOM && isHeaderShortExists) {
    headerFullDOM.style.display = isNotCheckout ? "block" : "none";
    headerShortDOM.style.display = isNotCheckout ? "none" : "block";
  }
}
